module.exports = window.__LR__.dependencies.load("current-context-urn");